import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerAddressAdd = createAsyncThunk(
  "customerAddressAddList/getCustomerAddressAdd",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customerAddress/Add`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerAddAddressSlice = createSlice({
  name: "customerAddressAddList",
  initialState: {
    loading: false,
    customerAddressAddData: null,
    error: null,
  },
  reducers: {
    ResetAddAddressState: (state) => {
      state.loading = false;
      state.customerAddressAddData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerAddressAdd.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerAddressAdd.fulfilled, (state, action) => {
        state.loading = false;
        state.customerAddressAddData = action.payload;
      })
      .addCase(getCustomerAddressAdd.rejected, (state, action) => {
        state.loading = false;
        state.customerAddressAddData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetAddAddressState } = customerAddAddressSlice.actions;
export default customerAddAddressSlice.reducer;
